var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.startObj && _vm.timezone)?_c('div',{staticClass:"calendar-item-time"},[_vm._v(" "+_vm._s(_vm.asTimeOnly(_vm.item.startObj, _vm.timezone))+" "),_c('span',[_vm._v(" - ")]),_vm._v(" "+_vm._s(_vm.asTimeOnly(_vm.item.endObj, _vm.timezone))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }